// Left-aligned plain-text AI reply bubble with the AI avatar.
// Ported from designproject/files/screens-feed.jsx (AIText) — the refItem
// "open card" affordance is intentionally omitted; in Phase 1.4 we only
// render the text body. The card-open variant lives with AISummary
// (Phase 1.5) where it has a real consumer.

import type { JSX } from 'preact';
import { T, Avatar } from '../../tokens';

export interface AITextProps {
  readonly text: string;
  readonly time?: string;
}

export function AIText({ text, time }: AITextProps): JSX.Element {
  return (
    <div style={{ padding: '4px 16px', display: 'flex', gap: 10, alignItems: 'flex-start' }}>
      <Avatar kind="ai" icon="spark" size={28} />
      <div style={{ minWidth: 0, maxWidth: '78%' }}>
        <div
          style={{
            background: T.surface,
            border: `1px solid ${T.border}`,
            padding: '12px 14px',
            borderRadius: '4px 18px 18px 18px',
            fontSize: 14.5,
            lineHeight: 1.4,
            color: T.ink,
            fontWeight: 500,
          }}
        >
          {text}
        </div>
        {time !== undefined && (
          <div style={{ fontSize: 11, color: T.ink3, marginTop: 4, fontWeight: 500 }}>
            {time}
          </div>
        )}
      </div>
    </div>
  );
}
